export const temperatureDetails = [
    'Felt Temp.',
    'Humidity',
    'Wind',
    'Visibility',
    'Max Temp.',
    'Min Temp.'
];

export const forecastDetails = [
    'Felt Temp.',
    'Humidity',
    'Wind',
    'Pressure',
    'Day Temp.',
    'Evening Temp.',
    'Night Temp.',
    'Max Temp.',
    'Min Temp.'
];